import styled from "styled-components";

export const InvoiceButton = styled.button`
  border: none;
  cursor: pointer;
  background: none;

  &:hover {
    background-color: #fff;
    opacity: 0.7;
    border-radius: 5px;
    border: 1px solid #f0292a;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #f5f5f5;
    color: #aaa;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
`;
